import './registerCards';
import type { ModuleRoute } from '../types';
import { DeliveriesPage } from './DeliveriesPage';
import { EventPage } from './EventPage';
import { EventsPage } from './EventsPage';
import { OccupancyPage } from './OccupancyPage';
import { RemoteSitePage } from './RemoteSitePage';
import { SignInPointsPage } from './SignInPointsPage';

/** Pages of this area (contactless set-up, sign-in points, remote site, deliveries, events, occupancy). Owned by Phase 3 task W20; only that task edits files in this folder (W23 wires it last). */
export const routes: ModuleRoute[] = [
  { path: '/manage/sign-in-points', element: <SignInPointsPage />, permission: 'sign_in_points.manage' },
  { path: '/manage/remote-site', element: <RemoteSitePage />, permission: 'sites.view' },
  { path: '/deliveries', element: <DeliveriesPage />, permission: 'deliveries.view' },
  { path: '/events', element: <EventsPage />, permission: 'events.view' },
  { path: '/events/:id', element: <EventPage />, permission: 'events.view' },
  { path: '/occupancy', element: <OccupancyPage />, permission: 'occupancy.view' },
];
